<!--
 * @Author: Y.SY
 * @Date: 2020-2-22
 * @LastEditors  : Y.SY
 * @Description: 我的订单详情头部进度条
 * @Remarks:
 -->
<template>
  <div class="od-progress">
    <div class="od-oper">
      <div class="od-oper-status">{{ getStatusText(status) }}</div>
      <div class="handler-wrapper">
        <el-button type="success" :id="'pay' + order.id" size="medium" @click.stop="goToPayPage(order)" round v-if="status === 0"> {{ opTimeCounter(order, 'pay', '立即付款') || '立即付款' }}
        </el-button>
        <el-button type="text" class="text-button" @click.stop="cancelOrder(order)" v-if="status === 0||status===4">取消订单
        </el-button>
        <el-button type="success" :id="'comment' + order.id" @click.stop="goToEvaluate(order)" round v-if="status === 6"> {{ opTimeCounter(order, 'comment', '评价') || '评价' }}
        </el-button>
        <el-button type="success" size="medium" @click.stop="deliveryGoods(order)" round v-if="status === 8">确认收货
        </el-button>
        <el-button type="success" size="medium" round
                   @click.stop="createInvoice(order)"
                   v-if="ivShow(order) && order.type !== 3 && isApplyInvoice === 1 && status===3"
                  >
          补开发票
        </el-button>
        <!-- v-if="ivShow(order) && order.type !== 3 && isApplyInvoice === 1 && status===3" -->
        <el-button type="text" class="text-button" size="medium" round
                   @click.stop="goInvoiceDetailPage(order)" v-if="isApplyInvoice === 0&&(status===1||status===3||status===6||status===7||status===8)">
          查看发票
        </el-button>
        <el-button :type="'text'" class="text-button" size="medium" round
                   @click.stop="queryQrCode(order)" v-if="(status===1) && (order.isOnTrain == 2)">
          查看二维码
        </el-button>
      </div>
    </div>
    <div class="od-divider"></div>
    <od-status-progress class="od-progress-bar" :progressStatus="progressStatus"/>
    <!-- <invoice-info :show="showInvoice" :orderId="order.id" @visibleUpdate="visibleUpdate"></invoice-info> -->
    <od-qrcode-dialog :selectedOrder="order" :show="qrDialogShow" @qrcodeDialogClose="qrcodeDialogClose"/>
  </div>
</template>

<script>
import OdStatusProgress from '@/components/od-status-progress'
import OdQrcodeDialog from '@/components/od-qrcode-dialog'
import API from '@/api/api'
export default {
  props: ['orderProp'],
  data () {
    return {
      tempOrder: {},
      status: -1,
      isApplyInvoice: 0,
      qrDialogShow: false,
      showInvoice: false,
      btTimer: null,
      statusMap: {
        '0': '待支付',
        '1': '已支付',
        '2': '支付中',
        '3': '已完成',
        '4': '待确认',
        '-1': '已退款',
        '5': '已取消',
        '6': '待评价',
        '7': '待发货',
        '8': '已发货',
        '9': '支付超时关闭',
        '1001': '操作超时'
      }
    }
  },
  computed: {
    order () {
      return this.tempOrder
    },
    // status: function () {
    //   return this.order.status
    // },
    progressStatus: function (v) {
      /*
      * 1. 提交订单：0,2
        2. 支付完成：1,4
        3. 处理完成：6,7,8
        4. 订单完成：3,-1,5,9
      * */
      if (this.status === 0 || this.status === 2 || this.status === 4) {
        return 1
      } else if (this.status === 1) {
        return 2
      } else if (this.status === 6 || this.status === 7 || this.status === 8) {
        return 3
      } else {
        return 4
      }
    }
  },
  created () {

  },
  mounted () {

  },
  activated () {

  },
  deactivated () {
    if (this.btTimer) {
      clearInterval(this.btTimer)
    }
  },
  watch: {
    orderProp: function (v, o) {
      this.status = v.status
      this.isApplyInvoice = v.isApplyInvoice
      this.tempOrder = v
      // console.log('orderProp change')
      // console.log(this.order)
    }
  },
  methods: {
    opTimeCounter (order, id, name) {
      if (order) {
        this.btTimer = this.btnTimeCounter(
          order,
          id,
          name,
          () => {
            console.log('orderDetailUpdate')
            this.$emit('orderDetailUpdate')
          },
          () => {
            // console.log('orderOperationExpire')
            // this.tempOrder.status = 3
            // console.log(this.tempOrder)
            this.status = '1001'
            this.isApplyInvoice = -1
          }
        )
      }
    },
    ivShow (item) {
      return this.priceDis(item) !== '￥0.00'
    },
    async deliveryGoodsAPI (i) {
      const res = await API.cancelOrder({ orderId: i.id, status: 3 })
      if (res.data.statusCode === '200') {
        // window.location.reload()
        this.$emit('orderDetailUpdate')
        this.$message({
          type: 'success',
          message: res.data.result
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.data.result
        })
      }
    },
    async handleCancelOrder (i) {
      const res = await API.cancelOrder({ orderId: i.id, status: 5 })
      if (res.data.statusCode === '200') {
        // window.location.reload()
        this.$emit('orderDetailUpdate')
        this.$message({
          type: 'success',
          message: res.data.result
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.data.result
        })
      }
    },
    goOrderDetail (i) {
      // const url = window.location.origin
      // window.open(`${url}/orderDetail/${i.id}`)
      this.$router.push({ path: `/orderDetail/${i.id}` })
    },
    qrcodeDialogClose (v) {
      this.qrDialogShow = v
    },
    // visibleUpdate (b) {
    //   this.showInvoice = b
    //   console.log(b)
    //   if (!b) {
    //     this.$emit('orderDetailUpdate')
    //   }
    // },
    getStatusText (status) {
      console.log(status)
      return this.statusMap[status]
    },
    goToEvaluate (i) {
      this.$router.push({ name: 'evaluate', query: { orderId: i.id } })
    },
    deliveryGoods (i) {
      let _this = this
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.deliveryGoodsAPI(i)
      }).catch(() => {

      })
    },
    cancelOrder (i) {
      let _this = this
      this.$confirm('是否取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.handleCancelOrder(i)
      }).catch(() => {

      })
    },
    goToPayPage (i) {
      this.$router.push({ name: 'payQRCode', query: { orderId: i.id, orderNumber: i.orderNumber } })
    },
    createInvoice (i) {
      this.showInvoice = true
    },
    goInvoiceDetailPage (i) {
      window.open(i.invoiceUrl)
    },
    queryQrCode (i) {
      this.qrDialogShow = true
      // setTimeout(() => {
      //   this.selectedOrder = i
      //   var canvas = document.getElementById('qrcode')
      //   QRCode.toCanvas(canvas, `http://kentrasoft.com/js-esp-mobile/#/sweep-code?orderNumber=${i.orderNumber}`, { width: 200 }, function (error) {
      //     if (error) console.error(error)
      //   })
      // }, 300)
    }
  },
  components: {
    OdStatusProgress,
    OdQrcodeDialog
  }
}
</script>

<style lang="stylus">
.od-progress
  width auto
  min-height 100px
  display flex
  background white
  flex-direction row
  justify-content flex-start
  align-items center
  padding 30px 70px 30px 70px
  .od-oper
    width 25%
    height auto
    display flex
    flex-direction column
    justify-content flex-start
    align-items center
    .od-oper-status
      width auto
      margin-bottom 17px
      color rgba(255,157,85,1)
      font-size 16px
    .handler-wrapper
      flex-grow 1
      width 100%
      display flex
      flex-direction column
      justify-content center
      align-items center
      .text-button
        color #999999
        font-size 14px
        font-weight 400
        /*margin-right 10px*/
  .od-divider
    width 1px
    height 100px
    background rgba(229,229,229,1)
  .od-progress-bar
    flex-grow 1
    width 200px
    height auto
    .od-node
      display flex
      flex-direction column
      align-items center
      justify-content center
      img
        margin-bottom 12px
        width 25px
        height 25px
      span
        color #31A826
        font-size 16px
    .order_status_divider
      padding-bottom 30px
</style>
